import Slider1 from '../images/slider/Land-frieght.jpeg';
import Slider2 from '../images/slider/Air-frieght.jpeg';
import Slider3 from '../images/slider/slider-3.jpg';

const sliderData = [
  {
    id: 1,
    bgText: "Transport",
    title: "Domestic Transport",
    subTitle: "Local & interstate freight solutions",
    description: `We deliver reliable domestic transport services across local and interstate routes,
    offering tailored freight solutions, scheduled services and dedicated point-to-point
    deliveries backed by professional coordination and real-time visibility.`,
    image: Slider1
  },
  {
    id: 2,
    bgText: "Air, Land & Sea",
    title: "Complete Logistics Solutions",
    subTitle: "Warehousing – Flexible storage & supply chain support",
    description: `We provide complete logistics solutions connecting air, land and sea transportation.
  Our warehousing services offer flexible short- and long-term storage, inventory
  management, and seamless integration with transport operations to ensure
  efficient and reliable supply chain performance.`,
    image: Slider2
  },
  {
    id: 3,
    bgText: "Projects",
    title: "Project Logistics",
    subTitle: "Specialised handling for complex projects",
    description: `Our project logistics team manages complex and time-critical freight with
    end-to-end planning, precise coordination and safe execution — ensuring
    oversized, high-value and specialised cargo is delivered efficiently.`,
    image: Slider3
  }
];

export default sliderData;